import React from 'react';
import { Nav,Navbar,InputGroup, InputGroupAddon, Collapse, Table, Form, FormGroup, Col, Input, Button, Container, Spinner } from 'reactstrap';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

export default class Productos extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            cargando:true,
            formVisible: false,
            clave: '',
            nombre:'?',
            objeto:{},
            objetos: [],
            lineas:[],
            unidades:[]
        };
        this.cargarCatalogos();
        this.cargarObjetos();
    }
    onFormClose = () => {
        this.setState({
            formVisible: false
        });
    }
    cargarObjetos = async () => {
        this.setState({cargando:true});
        const url = `${this.props.urlws}/articulo/articulos?depto=2&filtro=${this.state.nombre}`;
        const resp = await fetch(url);
        const objetos = await resp.json();
        this.setState({cargando:false, objetos });
    }
    cargarCatalogos = async () => {
        this.setState({cargando:true});
        let url = `${this.props.urlws}/articulo/lineas/2`;
        let resp = await fetch(url);
        const lineas = await resp.json();
        url = `${this.props.urlws}/articulo/unidades`;
        resp = await fetch(url);
        const unidades = await resp.json();
        this.setState({cargando:false, lineas, unidades });
    }
    onSubmit = (e) => {
        e.preventDefault();
        this.cargarObjetos();
    }
    onChange = (e) => {
        this.setState({ [e.target.name] : e.target.value});
    }
    onBntBuscarClick = () =>{
        this.cargarObjetos();
    }    
    cargar = async (cve) => {
        this.setState({cargando:true});
        const url = this.props.urlws + "/articulo/cargar/" + cve;
        const resp = await fetch(url);
        const objeto = await resp.json();
        if(objeto.Depto > 0 && objeto.Depto !== 2){
            Swal.fire('Atencion',objeto.Nombre + " no un producto",'error');
            this.setState({cargando:false});
            return;
        }
        if(objeto.Codigo == ''){
            objeto.Codigo = cve;
            objeto.Depto = 2;
            objeto.Linea = 1;
            objeto.Sublinea = 1;
         }
         this.setState({
            cargando:false,
            formVisible: true,
            clave: cve,
            objeto
        });
    }
    guardar = async(dato) =>{
        const url = this.props.urlws +"/articulo/wsguardar";
        this.setState({cargando:true});
        if(dato.Codigo ==='NUEVO')
           dato.Codigo = '';
        const json = JSON.stringify(dato);
        const resp = await fetch(url,{
            method: 'POST', // or 'PUT'
            body: json // data can be `string` or {object}!
          });
        const res = await resp.text();
        this.setState({cargando:false});
        if(res === "ok"){
            Swal.fire('Atencion','Datos guardados','success');
            this.onFormClose();
        }
        else
            Swal.fire('Atencion',res,'error');
    }
    guardarUnidad = async(dato) =>{
        const url = this.props.urlws +"/articulo/agregaUnidad/" + dato;
        this.setState({cargando:true});
        const resp = await fetch(url);
        const res = await resp.text();
        this.setState({cargando:false});
        if(res === "ok"){
            Swal.fire('Atencion','Dato guardado','success');
            this.cargarCatalogos();
        }
        else
            Swal.fire('Atencion',res,'error');
    }
    nuevo = () => {
        this.cargar("NUEVO");
    }
    imprimir = () =>{
        const url = `${this.props.urlws}/articulo/productosPdf`;
        window.open(url, '', '');
    }
    render() {
        const estilo = { display: this.state.formVisible ? 'none' : 'inline' };
        return (
            <Container >
                {this.state.cargando ?
                <div className="loader">
                    <Spinner animation="border" color="primary"/>
                </div>
                : 
                null
                }
                <div style={estilo}>
                <Navbar bg="f5e831" expand="lg">
                    <Collapse isOpen={true} id="basic-navbar-nav">
                        <Nav className="mr-auto" size="sm">
                            <Button size="sm" color="success" outline onClick={this.nuevo}><img src="/imagenes/add.png"/></Button>
                            &nbsp;
                            <Form inline onSubmit={this.onSubmit} >
                            <label size="sm">Nombre</label>&nbsp;
                            <InputGroup>
                                <Input size="sm" type="text" placeholder="Buscar" name="nombre" onChange={this.onChange} style={{width:400}} />
                                <InputGroupAddon addonType="append">
                                    <Button size="sm" color="success" onClick={this.onBntBuscarClick}> Buscar <img src="/imagenes/zoom.png" /> </Button>
                                </InputGroupAddon>
                            </InputGroup>                            
                            &nbsp;
                            &nbsp;
                            <Button size="sm" color="success" outline onClick={this.imprimir}><img src="/imagenes/printer.png"/></Button>
                            &nbsp;
                            <Button size="sm" color="success" outline onClick={this.excel}><img src="/imagenes/excel.png"/></Button>
                        </Form>
                        </Nav>
                    </Collapse>
                </Navbar>
                <div style={{ height: 4 }}></div>
                    <ObjetoTable objetos={this.state.objetos} height={500} width={990} onRowClick={this.cargar} />
                </div>
                <ObjetoForm urlws={this.props.urlws} visible={this.state.formVisible} lineas={this.state.lineas} unidades={this.state.unidades} objeto={this.state.objeto} onClose={this.onFormClose} clave={this.state.clave} guardar={this.guardar} guardarUnidad={this.guardarUnidad}/>
            </Container>
        );
    }
}

class ObjetoTable extends React.Component {
    onRowClick = (cve) => {
        this.props.onRowClick(cve);
    }
    render() {
        let { objetos } = this.props;
        return (
            <div style={{ height: this.props.height, width:this.props.width, overflow: 'auto' }}>
            <Table striped bordered hover size="sm">
                <thead>
                    <tr>
                        <th style={{width:100}}>Codigo</th>
                        <th>Nombre</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {objetos.map((o, i) => (
                        <ObjetoRow key={i} objeto={o} onRowClick={this.onRowClick} />
                    ))}
                </tbody>
                </Table>
            </div>
        );
    }
}

class ObjetoRow extends React.Component{
    onClick = (e) =>{
        this.props.onRowClick(this.props.objeto.I);
    }
    render(){
        let {objeto} = this.props;
        return (
        <tr>
            <td>{objeto.I}</td>
            <td>{objeto.N}</td>
            <td>
                <img src="/imagenes/edit.png" onClick={this.onClick} alt="editar" title="editar"/>            
            </td>
        </tr>
        );
    }
}

class ObjetoForm extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            //articulo:this.props.articulo,
            objeto:this.props.objeto,
            //...this.props.objeto,
            sublineas:[],
            lin:0
        };
        this.cargarSublineas(this.state.objeto.Linea);
    }
    componentWillReceiveProps(newProps){
        this.setState({
            objeto:newProps.objeto,
            //...newProps.articulo
        });
        this.cargarSublineas(newProps.objeto.Linea);
    }
    cargarSublineas = async (lin) => {
        //alert(this.state.lin + ' === ' + lin);
        if(this.state.lin === lin)
            return;
        this.setState({cargando:true,lin:lin});
        const url = `${this.props.urlws}/articulo/sublineas?depto=2&linea=${lin}`;
        const resp = await fetch(url);
        const sublineas = await resp.json();
        this.setState({cargando:false, sublineas });
    }
    onChange = (e) => {
        const campo = e.target.name;
        const obj = {
            ...this.state.objeto,
            [campo] : e.target.value
        };
        this.setState({objeto:obj},() =>{
            if(campo === "Linea")
               this.cargarSublineas(obj.Linea);
        });
    }
    guardar = () =>{
        const MySwal = withReactContent(Swal)
        MySwal.fire({
            title: 'Confirme',
            text: "¿ Desea guardar estos datos ?",
            type: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            cancelButtonText: 'No',
            confirmButtonText: 'Si'
          }).then((result) => {
            if (result.value) {
                this.props.guardar(this.state.objeto);
            }
          })        
    }
    agregarUnidad = async() =>{
        const { value: unidad } = await Swal.fire({
            title: 'Agregar unidad de medida',
            input: 'text',
            inputValue: '',
            showCancelButton: true,
            inputValidator: (value) => {
              if (!value) {
                return 'Debe escribir una unidad de medida.'
              }
            }
          })          
          if (unidad) {
            this.props.guardarUnidad(unidad);
          }
    }
    render() {
        const estilo = { display: this.props.visible ? 'inline' : 'none'};
        if(this.props.objeto === undefined)
            return null;
        if(Object.keys(this.props.objeto).length === 0)
            return null;
        return (
            <Container style={estilo}>
                <Form>
                    <div class="row">
                        <div className="col-2">
                            <FormGroup md="2" >
                                <label>Codigo</label>
                                <Input size="sm" type="text" name="Codigo" value={this.state.objeto.Codigo} />
                            </FormGroup>
                        </div>
                        {' '}
                        <div className="col-10">
                            <FormGroup md="10">
                                <label>Nombre</label>
                                <Input size="sm" type="text" name="Nombre" value={this.state.objeto.Nombre} onChange={this.onChange} />
                            </FormGroup>
                        </div>
                    </div>
                    <div class="row">
                        <div className="col-3">
                            <FormGroup>
                                <label>Linea</label>
                                <Input size="sm" type="select" name="Linea" id="Linea" value={this.state.objeto.Linea} onChange={this.onChange}  >
                                    <option key={-1} value={-1}>Especifique</option>    
                                    {this.props.lineas.map((i,k) =>(
                                        <option key={i.I} value={i.I}>{i.N}</option>
                                    ))}
                                </Input>
                            </FormGroup>
                        </div>
                        <div className="col-3">
                            <FormGroup  >
                                <label>SubLinea</label>
                                <Input size="sm" type="select" name="Sublinea" id="Sublinea" value={this.state.objeto.Sublinea} onChange={this.onChange}  >
                                    <option key={-1} value={-1}>Especifique</option>    
                                    {this.state.sublineas.map((i,k) =>(
                                        <option key={i.I} value={i.I}>{i.N}</option>
                                    ))}
                                </Input>
                            </FormGroup>
                        </div>
                        <div className="col-3">
                            <FormGroup  >
                                <label>Unidad</label>
                                <InputGroup>
                                    <InputGroupAddon addonType="prepend">
                                        <Button size="sm" color="success" onClick={this.agregarUnidad}>+</Button>
                                    </InputGroupAddon>
                                    <Input size="sm" type="select" name="Unidad" id="Unidad" value={this.state.objeto.Unidad} onChange={this.onChange}  >
                                        <option key={-1} value="">Especifique</option>
                                        {this.props.unidades.map((i, k) => (
                                            <option key={i.I} value={i.I}>{i.N}</option>
                                        ))}
                                    </Input>
                                </InputGroup>
                            </FormGroup>
                        </div>
                        <div className="col-2">
                            <FormGroup  >
                                <label>Costo</label>
                                <Input size="sm" type="text" name="Costo" value={this.state.objeto.Costo} onChange={this.onChange} />
                            </FormGroup>
                        </div>
                        <div className="col-1">
                            <FormGroup  >
                                <label>Tasa IVA</label>
                                <Input size="sm" type="text" name="TasaIva" value={this.state.objeto.TasaIva} onChange={this.onChange} />
                            </FormGroup>
                        </div>
                    </div>
                </Form>
                <br />
                <Button color="primary" onClick={this.guardar}>Aceptar</Button>
                {'  '}
                <Button color="danger" onClick={this.props.onClose}>Cancelar</Button>
            </Container>
        );
    }
}